<template>
    <div v-if="props.items">
        <ImageSliderCe v-if="windowWidth <= 600" :items="props.items?.map((v) => {
            return { ...v.preview }
        })"
        @event:image-clicked="emit('event:imageClicked', $event)"
        ></ImageSliderCe>
        <ProductImagesCe v-else class="mx-auto" :images-url="props.items"
        @event:image-clicked="emit('event:imageClicked', $event)"
        ></ProductImagesCe>
    </div>
</template>
<script lang="ts" setup>
import type { ImgProduct } from '@/types/book_item';
import ImageSliderCe from '@/components/image_slider/ImageSlider.ce.vue';
import ProductImagesCe from '@/components/product/ProductImages.ce.vue';
import { useWindowSize } from '@vueuse/core';
const { width: windowWidth } = useWindowSize()

const props = defineProps<{
    items?: ImgProduct[]
}>()

const emit = defineEmits<{
    (e: 'event:imageClicked', index: number):void
}>()
</script>